import React, { useEffect, useState } from "react";
import PageTab from "@/components/i-pageTab/i-pageTab";
import PageTable from "@/components/i-pageTable/i-pageTable";
import { getAreaDeviceList, exportAreaDeviceList } from "@/api/operation";
import { areaTree } from "@/api/setting";
import { useCascader } from "@/hooks/useCascader";
import { setIcons, downloadFile, getTimeFormat } from "@/utils/common";

const levelTypeData = [
  { label: "省级", value: "1" },
  { label: "市级", value: "2" },
  { label: "区级", value: "3" },
];

const ChannelEquipmentStatistics = () => {
  const [pageData, setPageData] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [formData, setFormData] = useState<any>({
    ypageNum: 1,
    ypageSize: 10,
  });

  const { cascaderProps } = useCascader({
    fetchData: areaTree as any,
    initId: [100000],
  });

  const formTab = [
    {
      label: "渠道等级",
      name: "levelType",
      type: "select",
      options: levelTypeData,
    },
    {
      label: "区域范围",
      name: "areaIds",
      type: "cascader",
      params: {
        ...cascaderProps,
        style: {
          width: "180px",
        },
      },
    },
    // {
    //   label: "是否有渠道代理",
    //   name: "hasChannelAgent",
    //   type: "select",
    //   options: [
    //     { label: "是", value: "1" },
    //     { label: "否", value: "0" },
    //   ],
    // },
  ];

  const columns = [
    {
      title: "渠道等级",
      dataIndex: "levelType",
      key: "levelType",
      render: (val: string) =>
        levelTypeData.find((i) => i.value === val)?.label,
    },
    {
      title: "区域范围",
      dataIndex: "provinceName",
      key: "areaName",
      render: (_: any, record: any) => {
        const parts = [
          record.provinceName,
          record.cityName,
          record.districtName,
        ].filter(Boolean);
        return parts.join("-");
      },
    },
    {
      title: "12口设备量",
      dataIndex: "deviceTypeZeroNumber",
      key: "deviceTypeZeroNumber",
    },
    {
      title: "12口购买金额",
      dataIndex: "deviceTypeZeroAmount",
      key: "deviceTypeZeroAmount",
    },
    {
      title: "6口设备量",
      dataIndex: "deviceTypeOneNumber",
      key: "deviceTypeOneNumber",
    },
    {
      title: "6口购买金额",
      dataIndex: "deviceTypeOneAmount",
      key: "deviceTypeOneAmount",
    },
    {
      title: "36口设备量",
      dataIndex: "deviceTypeTwoNumber",
      key: "deviceTypeTwoNumber",
    },
    {
      title: "36口购买金额",
      dataIndex: "deviceTypeTwoAmount",
      key: "deviceTypeTwoAmount",
    },
    {
      title: "6口广告设备量",
      dataIndex: "deviceTypeThreeNumber",
      key: "deviceTypeThreeNumber",
    },
    {
      title: "6口广告购买金额",
      dataIndex: "deviceTypeThreeAmount",
      key: "deviceTypeThreeAmount",
    },
    {
      title: "18口广告设备量",
      dataIndex: "deviceTypeFourNumber",
      key: "deviceTypeFourNumber",
    },
    {
      title: "18口广告购买金额",
      dataIndex: "deviceTypeFourAmount",
      key: "deviceTypeFourAmount",
    },
    {
      title: "累计设备量",
      dataIndex: "allDeviceNumber",
      key: "allDeviceNumber",
    },
    {
      title: "累计购买金额",
      dataIndex: "allDeviceAmount",
      key: "allDeviceAmount",
    },
    {
      title: "渠道代理昵称",
      dataIndex: "channelAgentNickName",
      key: "channelAgentNickName",
    },
    {
      title: "渠道代理账号",
      dataIndex: "channelAgentMobile",
      key: "channelAgentMobile",
    },
  ];

  const footer = [
    {
      title: "导出",
      onClick: () => exportData(),
      loading: exportLoading,
      icon: setIcons("DownloadOutlined"),
    },
  ];

  useEffect(() => {
    getPageData();
  }, [formData]);

  const exportData = async () => {
    try {
      setExportLoading(true);
      const params: any = {
        ...formData,
        provinceId: formData.areaIds?.[0],
        cityId: formData.areaIds?.[1],
        districtId: formData.areaIds?.[2],
      };
      delete params.areaIds;
      const data = await exportAreaDeviceList(params);
      downloadFile(
        data as any,
        "渠道设备统计" + getTimeFormat(new Date(), "yyyy-MM-dd HH:mm:ss")
      );
    } catch (error) {
    } finally {
      setExportLoading(false);
    }
  };

  const getPageData = async () => {
    setLoading(true);
    const params: any = {
      ...formData,
      provinceId: formData.areaIds?.[0],
      cityId: formData.areaIds?.[1],
      districtId: formData.areaIds?.[2],
    };
    delete params.areaIds;
    try {
      const data = await getAreaDeviceList(params);
      setPageData(data.rows);
      setTotal(data.total);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const search = (val: any) => {
    setFormData({
      ...formData,
      ...val,
      ypageNum: 1,
    });
  };

  const reset = () => {
    setFormData({
      ypageNum: 1,
      ypageSize: 10,
    });
  };

  const pageChange = (current: number, pageSize: number) => {
    setFormData({
      ...formData,
      ypageNum: current,
      ypageSize: pageSize,
    });
  };

  return (
    <div>
      <PageTab
        search={search}
        reset={reset}
        formTab={formTab}
        footer={footer}
      ></PageTab>
      <PageTable
        loading={loading}
        pageChange={pageChange}
        size="small"
        rowKey={(record: any) =>
          `${record.provinceId}-${record.cityId}-${record.districtId}`
        }
        columns={columns}
        data={pageData}
        pagination={{
          current: formData.ypageNum!,
          pageSize: formData.ypageSize!,
          total: total,
        }}
      ></PageTable>
    </div>
  );
};

export default ChannelEquipmentStatistics;
